import React from 'react';
import InfoBubble from '@gp/components/InfoBubble';

import type { IRecord } from '@gp/types/global';

const SELECT_SOURCE_BUBBLE_MAP: IRecord<string> = {
  internal: 'Work for hire projects with studio involvement are not included.',
  intelligence: 'All projects in which the studio is involved in R&D and published are included.',
};

export const sourceOptionTextRenderer = (option?: IGPSelectOptionWithGroup | null): React.ReactElement => {
  const { value = '', label } = option || {};
  return (
    <InfoBubble
      style={{ display: 'inline-block', width: '100%' }}
      className="globalpedia-modal-font14"
      DomOrText={label}
      customBubbleContent={SELECT_SOURCE_BUBBLE_MAP[value]}
    />
  );
};
